import { useCallback } from 'react';

let forceResubscribeRef: (() => void) | null = null;

export function setForceResubscribeRef(fn: (() => void) | null) {
	forceResubscribeRef = fn;
}

export function useForceSlotResubscribe() {
	return useCallback(() => {
		forceResubscribeRef?.();
	}, []);
}
